import request from './request'

export function fetchCases (params = {}) {
  return request.get('/cases', { params })
}

export function createCase (payload) {
  return request.post('/cases', payload)
}

export function updateCase (id, payload) {
  return request.put(`/cases/${id}`, payload)
}

export function deleteCase (id) {
  return request.delete(`/cases/${id}`)
}
